import React, {useEffect, useState} from 'react'
import { renderSectionHtml } from "../helpers/siteApi";

type BladeBlockPreviewProps = {
    keyName: string;
    value: any;
    selected?: boolean;
    onSelect?: () => void;
    inlineCss?: boolean;
    /** Меняй это число, чтобы вручную обновить превью */
    refreshKey: number;
};

const BladeBlockPreview: React.FC<BladeBlockPreviewProps> = ({
                                                                 keyName,
                                                                 value,
                                                                 selected = false,
                                                                 onSelect,
                                                                 inlineCss = false,
                                                                 refreshKey,
                                                             }) => {
    const [html, setHtml] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                setIsLoading(true);
                setErrorMessage(null);
                const markup = await renderSectionHtml(keyName, value, inlineCss);
                if (!cancelled) setHtml(markup);
            } catch (e: any) {
                if (!cancelled) setErrorMessage(e?.message || "Ошибка превью");
            } finally {
                if (!cancelled) setIsLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
        // ⬇️ реагируем ТОЛЬКО на смену типа секции или нажатие "Показать"
    }, [keyName, refreshKey, inlineCss]);

    return (
        <div
            onClick={onSelect}
            style={{
                border: selected ? "2px solid #4f46e5" : "1px dashed #cbd5e1",
                marginBottom: 12,
                background: "#fff",
            }}
        >
            {isLoading && <div style={{ padding: 16, color: "#64748b" }}>Загрузка превью…</div>}
            {errorMessage && <div style={{ padding: 16, color: "#b91c1c" }}>{errorMessage}</div>}
            {!isLoading && !errorMessage && (
                <iframe
                    title={`site-preview:${keyName}`}
                    style={{ width: "100%", border: 0, minHeight: 500 }}
                    sandbox="allow-popups allow-forms allow-same-origin allow-scripts"
                    srcDoc={html}
                />
            )}
        </div>
    );
};

export default BladeBlockPreview;